module.exports = {
  name: "NAME",
  address: "HOST/PORT",
  status: "STATUS",
  health: "HEALTH",
  cpus: "CPU",
  mem: "MEM",
  updated: "UPDATED",
  version: "VERSION"
};



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/PodTableHeaderLabels.js